'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var post = exports.post = function post(url, data) {
    var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-type', contentType);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                resolve(xhr.responseText);
            } else if (xhr.readyState === XMLHttpRequest.DONE && xhr.status !== 200) {
                reject(xhr.responseText);
            }
        };

        if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
            data = JSON.stringify(data);
        }

        xhr.send(data);
    });
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/util/ajax.js
// module id = ./resources/assets/js/src/util/ajax.js
// module chunks = 0